// extracted by mini-css-extract-plugin
export default {"form":"EditModal_form__X0H9p"};